import { useArAgingData } from './useArAgingData';
import { ArAgingTable } from './ArAgingTable';

const ArAgingReports = () => {
  const { rows, isLoading, totalCount } = useArAgingData();

  return (
    <div className="flex flex-col w-full h-full pt-4">
      <ArAgingTable data={rows} isLoading={isLoading} totalCount={totalCount} />
    </div>
  );
};

export default ArAgingReports;
